export function yyyymmdd(date: Date): string {
    let m = date.getMonth() > 9 ? date.getMonth() : "0" + date.getMonth();
    return date.getFullYear() + "-" + (Number(m) + 1) + "-" + date.getDate();
}